<div class="container">
  <div class="row">
    <div class="col-12">
      <form>
        <div class="working-director-wrapper">

          <crm-alert #alert></crm-alert>

          <label class="rbv-label">Working Directory</label>

          <div class="folder-picker">
            <input class="form-control rounded-0" readonly [value]="user.WORKING_DIRECTORY ? user.WORKING_DIRECTORY : ''"/>
            <button type="button" class="btn btn-rbv" (click)="pickFolder()" [disabled]="!chromeAppInstalled">
              <fa name="fa fa-folder-open-o"></fa>
              Pick Folder
            </button>
          </div>

          <div class="desc-floating">NOTICE: You must have Browser Extension installed</div>

          <div class="desc-floating error" *ngIf="!chromeAppInstalled">
            <fa name="fa fa-exclamation-triangle"></fa>
            Extension Not Installed
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
